import { Component, Input, Output, EventEmitter } from '@angular/core';

import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-export-download-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './export-download-modal.html',
  styleUrls: ['./export-download-modal.scss']
})

export class ExportDownloadModal {
  private _show = false;
  @Input()
  set show(val: boolean) {
    this._show = val;
    if (val) {
      this.step = 'choose';
    }
  }
  get show() {
    return this._show;
  }
  @Input() fileName = '';
  @Input() fileBlob: Blob | null = null;
  @Input() emailSubject = '';
  @Input() emailBody = '';
  @Input() simpleDisclaimerMode = false;
  @Input() warningTitle = 'Importante';
  @Input() warningPrefix = '';
  @Input() warningMessage = '';
  @Output() close = new EventEmitter<void>();
  @Output() download = new EventEmitter<void>();


  step: 'choose' | 'email-warning' | 'email' = 'choose';
  emailType: 'mailto' | 'outlookWeb' | 'outlook' = 'mailto';

  chooseDownload() {
    this.download.emit();
    this.close.emit();
  }

  chooseEmail() {
    this.step = 'email-warning';
  }

  confirmEmailWarning() {
    // Faz download automático ao confirmar
    if (this.fileBlob && this.fileName) {
      this.downloadFile(this.fileBlob, this.fileName);
    }
    this.step = 'email';
  }

  private downloadFile(blob: Blob, fileName: string) {
    const objectUrl = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = fileName;
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(objectUrl);
  }

  proceedToEmail(type: 'mailto' | 'outlookWeb'| 'outlook') {
    this.emailType = type;
    this.step = 'email';
  }

  onBackdropClick(event: MouseEvent) {
    this.close.emit();
  }
    
  sendEmail(type: 'mailto' | 'outlook' | 'outlookWeb') {
    // Só permite após aviso
    // Desabilitado: API de compartilhamento de arquivos causa erro em navegadores sem permissão
    // Fallbacks para diferentes apps
    this.proceedToEmail(type);
    // Após confirmação, executa ação
    if (type === 'outlookWeb') {
      // Outlook Web
      const encodeForOutlookWeb = (str: string) => encodeURIComponent(str).replace(/%20/g, ' ');
      const outlookWebUrl = `https://outlook.office.com/mail/deeplink/compose?subject=${encodeForOutlookWeb(this.emailSubject)}&body=${encodeForOutlookWeb(this.emailBody)}`;
      window.open(outlookWebUrl, '_blank');
    } else {
      // E-mail padrão
      const mailtoUrl = `mailto:?subject=${encodeURIComponent(this.emailSubject)}&body=${encodeURIComponent(this.emailBody)}`;
      window.location.href = mailtoUrl;
    }
    this.close.emit();
  }

  back() {
    this.step = 'choose';
  }
}
